export default "__VITE_ASSET__DYo_cBPw__"